import React from 'react';
import PropTypes from 'prop-types';
import styles from './EmptyPanel.css';

function EmptyPanel({ panelStyles }) {
  return (
    <div className={panelStyles} data-test-id="dmb-panel">
      <header className={styles.header}>
        <div className={`${styles.emptyTitle} ${styles.smallerHeight}`} />
        <div
          className={`${styles.emptyTitle} ${styles.smallerHeight} ${styles.smallerWidth}`}
        />
      </header>
      <div className={styles.card}>
        <div className={styles.emptyTitle} />
      </div>
      <div className={styles.card}>
        <div className={styles.emptyTitle} />
      </div>
      <div className={styles.card}>
        <div className={styles.emptyTitle} />
      </div>
      <div className={styles.card}>
        <div className={styles.emptyTitle} />
      </div>
    </div>
  );
}

EmptyPanel.propTypes = {
  panelStyles: PropTypes.string.isRequired,
};

export default EmptyPanel;
